import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import * as util from '../../util';
import { isWeixin } from '@ivy/fts/utils';
let CommonHeader = class CommonHeader extends Vue {
    constructor() {
        super(...arguments);
        this.isWeixin = isWeixin();
    }
    jumpToCenter() {
        util.toCenterKnowledgeList();
    }
};
CommonHeader = tslib_1.__decorate([
    Component
], CommonHeader);
export default CommonHeader;
